var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('code',[_vm._v(_vm._s(_vm.code)+" ")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.message)+" ")]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:history.back();"}},[_vm._v("\n        Back\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d3d5424","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
// module id = null
// module chunks = 